export interface RangeRateOption {
  value: string;
  label: string;
}

export const getRangeRateLabel = (
  options: RangeRateOption[] | undefined,
  index: number
): string => options?.[index]?.label ?? '';

export const getRangeRateValue = (
  options: RangeRateOption[] | undefined,
  selectedOptionId: string | null | undefined
): number => {
  if (!options?.length || !selectedOptionId) {
    return 0;
  }

  const selectedIndex = options.findIndex(
    (option) => option.value === selectedOptionId
  );

  if (selectedIndex === -1) {
    return 0;
  }

  return selectedIndex + 1;
};

export const getRangeOptionIdFromRateValue = (
  options: RangeRateOption[] | undefined,
  rateValue: number
): string | undefined => {
  if (!options?.length) {
    return undefined;
  }

  if (!Number.isFinite(rateValue) || rateValue < 1) {
    return undefined;
  }

  return options[rateValue - 1]?.value;
};
